export default function getAvatar() {
  return '/img/member-avatar.svg'
}

export function avatarInitial(name: string) {
  let initials = name.match(/\b\w/g) || []
  return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase()
}
